import { useSearchParams } from 'react-router-dom'

import ChainModule from './constructor/modules/chain/ChainModule'
import EpochModule from './constructor/modules/epoch/EpochModule'
import ReferralModule from './constructor/modules/referral/ReferralModule'
import StoplistModule from './constructor/modules/stoplist/StoplistModule'
import TokenModule from './constructor/modules/token/TokenModule'
import TokenInfoModule from './constructor/modules/tokeninfo/TokenInfoModule'
import TransactionModule from './constructor/modules/transaction/TransactionModule'
import TransferModule from './constructor/modules/transfer/TransferModule'
import { MODULE_REGISTRY, type SupportedModule } from './moduleRegistry'

const MODULE_COMPONENTS: Record<SupportedModule, React.ComponentType> = {
  transfer: TransferModule,
  stoplist: StoplistModule,
  referral: ReferralModule,
  chain: ChainModule,
  token: TokenModule,
  tokeninfo: TokenInfoModule,
  transaction: TransactionModule,
  epoch: EpochModule,
}

export default function CreateProposalConstructor() {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedModule = searchParams.get('module') as SupportedModule | null

  const selectModule = (module: SupportedModule) => {
    setSearchParams({ module })
  }

  const isValidModule = selectedModule && selectedModule in MODULE_COMPONENTS

  if (!isValidModule) {
    return (
      <div className='space-y-4'>
        <div className='space-y-2'>
          <h2 className='text-foreground text-lg font-semibold'>
            Select Module
          </h2>
          <p className='text-muted-foreground text-sm'>
            Choose a module to create a message
          </p>
        </div>

        <div className='grid gap-3 sm:grid-cols-2 lg:grid-cols-3'>
          {(
            Object.entries(MODULE_REGISTRY) as [
              SupportedModule,
              (typeof MODULE_REGISTRY)[SupportedModule],
            ][]
          ).map(([key, config]) => (
            <button
              key={key}
              type='button'
              onClick={() => selectModule(key)}
              className='border-border bg-card hover:border-primary/40 text-card-foreground flex flex-col items-start gap-2 rounded-lg border p-4 text-left transition-colors'
            >
              <div className='text-foreground font-semibold'>
                {config.label}
              </div>
              <p className='text-muted-foreground text-sm'>{config.overview}</p>
            </button>
          ))}
        </div>
      </div>
    )
  }

  const ModuleComponent = MODULE_COMPONENTS[selectedModule]

  return (
    <div className='space-y-4'>
      <ModuleComponent />
    </div>
  )
}
